function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, editingCustomComparison, windowErrorMsg) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-time-comparison-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!editingCustomComparison) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'time-comparison-options': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                sections: JSON.stringify($helpers.getTimeComparisonOptions()),
              }),
              "on": {
                clickItem: $helpers.onPresetTimeComparisonClick
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu-pane", {
            "attrs": __vjadeStringifyAttrsIfObj({
              header: 'Compare to Date',
              'show-back-button': true,
            }),
            "style": {
              'overflow': `visible`
            },
            "on": {
              'back-click': $helpers.onPaneBackClick
            },
            "class": {
              'mp-time-comparison-selector-menu': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-datepicker-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-date-range-picker", {
                "attrs": __vjadeStringifyAttrsIfObj($helpers.getDateRangePickerOptions()),
                "on": {
                  changeDateRange: $helpers.changedDateRange,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'disabled': !!windowErrorMsg,
              'tabindex': 0,
            }),
            "on": {
              click: $helpers.applyDateRange
            },
            "class": {
              'mp-button-bar-primary': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Apply");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "editingCustomComparison" in locals ? locals.editingCustomComparison : typeof editingCustomComparison !== "undefined" ? editingCustomComparison : undefined, "windowErrorMsg" in locals ? locals.windowErrorMsg : typeof windowErrorMsg !== "undefined" ? windowErrorMsg : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;